var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdviceA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 237,
    viewBox: "0 0 237 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3098_12314)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 236,
    transform: "translate(0.865723 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3098_12314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5778 14.3203C80.1206 24.4431 113.663 34.5858 147.205 44.7086C147.291 91.3884 147.376 138.068 147.461 184.768L46.831 149.552C46.7403 104.468 46.6685 59.4045 46.5778 14.3203Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.965 39.7926C157.741 41.4667 152.517 43.121 147.314 44.7951L46.725 14.2218C52.6187 12.4878 58.5125 10.734 64.3866 9C97.2459 19.2642 130.105 29.5284 162.965 39.7926Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M162.965 39.7926V175.499L147.314 184.847V44.7952L162.965 39.7926Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M56.1511 27.0819C56.1511 44.2978 56.1511 27.0819 56.1511 44.2978C83.2295 52.5024 56.1511 44.2978 83.2295 52.5024C83.4859 46.3047 83.2295 52.7613 83.2295 35.175C56.1511 27.0819 83.2295 35.1225 56.1511 27.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.252 136.606C114.252 136.606 105.892 136.977 100.698 132.693C95.5043 128.4 87.7412 120.58 83.6365 106.072C83.238 104.676 82.9257 103.317 82.6715 102.003L110.644 117.126L110.501 111.972L81.9457 96.3194C81.7931 93.8927 81.8461 91.709 82.0109 89.7997L110.316 105.325L110.17 100.046L82.7571 84.9548C83.2629 82.7105 83.7868 81.461 83.7868 81.461C83.7868 81.461 85.7779 74.054 93.1455 72.7349C100.513 71.4157 112.24 83.5638 112.24 83.5638L113.575 77.4196C111.871 75.3719 109.286 72.641 105.691 70.0152C103.382 68.3292 100.831 66.4777 97.1893 65.2602C94.16 64.255 88.1776 62.2616 82.6824 65.2025C75.3865 69.1038 74.7039 78.6271 74.6673 79.3555C74.6673 79.3555 74.6115 79.7304 74.5457 80.4309L67.8151 76.7264L67.9643 82.101L74.233 85.5411C74.1809 87.4184 74.1862 89.6579 74.312 92.1428L68.1492 88.7667L68.3013 94.2465L74.78 97.7476C75.8834 107.144 78.8781 118.506 86.2913 127.704C101.922 147.091 116.098 143.78 116.098 143.78L114.252 136.606Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3098_12314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0284 57.8237C97.5712 67.9465 131.113 78.0892 164.656 88.212C164.741 134.892 164.827 181.572 164.911 228.271L64.2816 193.056C64.1909 147.971 64.1191 102.908 64.0284 57.8237Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.415 83.296C175.192 84.9702 169.968 86.6244 164.764 88.2986L64.1755 57.7252C70.0693 55.9913 75.9631 54.2374 81.8372 52.5034C114.696 62.7676 147.556 73.0318 180.415 83.296Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M180.415 83.296V219.003L164.764 228.35V88.2986L180.415 83.296Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M73.6016 70.5853C73.6016 87.8012 73.6016 70.5853 73.6016 87.8012C100.68 96.0058 73.6016 87.8012 100.68 96.0058C100.936 89.8081 100.68 96.2647 100.68 78.6784C73.6016 70.5853 100.68 78.6259 73.6016 70.5853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.702 180.11C131.702 180.11 123.343 180.481 118.149 176.197C112.955 171.903 105.192 164.083 101.087 149.575C100.689 148.18 100.376 146.82 100.122 145.506L128.094 160.63L127.951 155.475L99.3963 139.823C99.2437 137.396 99.2967 135.212 99.4615 133.303L127.767 148.829L127.62 143.55L100.208 128.458C100.713 126.214 101.237 124.964 101.237 124.964C101.237 124.964 103.229 117.557 110.596 116.238C117.964 114.919 129.691 127.067 129.691 127.067L131.026 120.923C129.322 118.875 126.737 116.144 123.142 113.519C120.832 111.833 118.281 109.981 114.64 108.764C111.611 107.758 105.628 105.765 100.133 108.706C92.8371 112.607 92.1545 122.13 92.1179 122.859C92.1179 122.859 92.062 123.234 91.9962 123.934L85.2657 120.23L85.4148 125.604L91.6835 129.044C91.6315 130.922 91.6368 133.161 91.7626 135.646L85.5998 132.27L85.7518 137.75L92.2306 141.251C93.3339 150.647 96.3287 162.009 103.742 171.207C119.372 190.595 133.549 187.283 133.549 187.283L131.702 180.11Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3098_12314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 236,
    fill: "white",
    transform: "translate(0.865723 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3098_12314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.099,
    height: 175.847,
    fill: "white",
    transform: "translate(39.8657 9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3098_12314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.099,
    height: 175.847,
    fill: "white",
    transform: "translate(57.3163 52.5034)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviceA);
export default __webpack_public_path__ + "static/media/adviceA.da8c5d873af70115a4375a7a6db51cd6.svg";
export { ForwardRef as ReactComponent };